import PropTypes from 'prop-types'
import React from 'react'
import { Apps } from 'SRC/ui/FormElements'

export class ViberAndWhatsapp extends React.PureComponent {
  getField = () => ({
    id: `apps-${this.props.index}`,
    viberFieldName: `phones[${this.props.index}].viber`,
    whatsappFieldName: `phones[${this.props.index}].whatsapp`,
    label: `Imaš Viber i WhatsApp?`,
    formName: 'update',
    index: this.props.index
  })

  render () {
    return <Apps {...this.getField()} />
  }
}

ViberAndWhatsapp.propTypes = {
  index: PropTypes.number.isRequired
}

ViberAndWhatsapp.defaultProps = {
  index: 0
}
